module.exports = __webpack_public_path__ + "img/banner-linkedin.bddd7813.png";